<dynamic-input
  [inputConfig]="field"
  [formGroup]="formConfig.formGroup"
  *ngFor="let field of formConfig.fields"
></dynamic-input>
